import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

export const SITE_URL = "https://www.dotlands.in";
export const DEFAULT_OG = `${SITE_URL}/og-image.jpg`;

export const ORG_JSONLD = {
  "@context": "https://schema.org",
  "@type": "RealEstateAgent",
  name: "Dotlands Realty",
  url: SITE_URL,
  logo: `${SITE_URL}/logo.png`,
  image: DEFAULT_OG,
  description:
    "Dotlands Realty offers verified agricultural land, farm land, open plots, residential plots, commercial properties and homes for sale across Hyderabad and Telangana.",
  telephone: "+91-9392108692",
  email: "dotlandsrealty@gmail.com",
  priceRange: "₹₹",
  openingHours: "Mo-Sa 09:30-19:30",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Naik Complex, Kadthal",
    addressLocality: "Kadthal",
    addressRegion: "Telangana",
    postalCode: "509358",
    addressCountry: "IN",
  },
  areaServed: [
    { "@type": "AdministrativeArea", name: "Telangana" },
    { "@type": "City", name: "Hyderabad" },
  ],
  sameAs: [],
};

export const WEBSITE_JSONLD = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Dotlands Realty",
  url: SITE_URL,
  potentialAction: {
    "@type": "SearchAction",
    target: `${SITE_URL}/properties?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

export function Seo({ title, description, path, image, type = "website", noindex = false, jsonLd }) {
  const location = useLocation();
  const url = SITE_URL + (path || location.pathname);
  const img = image || DEFAULT_OG;
  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? "noindex,nofollow" : "index,follow,max-image-preview:large"} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Dotlands Realty" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />

      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(b)}</script>
      ))}
    </Helmet>
  );
}
